import { CheckOutlined, WarningOutlined } from '@ant-design/icons';
import { Modal, ModalProps, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

interface ConfirmRequestJobPostingApprovalModalProps extends ModalProps {
  requestJobPostingName: string;
}

const ConfirmRequestJobPostingApprovalModal = ({
  requestJobPostingName,
  ...props
}: ConfirmRequestJobPostingApprovalModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        <Typography.Text strong>
          <WarningOutlined /> <Trans>Atenção! Esta requisição será concluída!</Trans>
        </Typography.Text>
      }
      okButtonProps={{
        icon: <CheckOutlined />,
      }}
      okText={t('Aprovar')}
      cancelText={t('Cancelar')}
      {...props}
    >
      <Typography.Paragraph>
        <Trans>Ao aprovar a requisição</Trans>{' '}
        <Typography.Text strong>{requestJobPostingName}</Typography.Text>
        <Trans>
          , ela será concluída e a vaga correspondente será criada automaticamente na aba de
        </Trans>
        <Typography.Text strong>
          {' '}
          <Trans>Vagas</Trans>.{' '}
        </Typography.Text>
        <Trans>Não haverá possibilidade de reiniciar a requisição após a conclusão.</Trans>
      </Typography.Paragraph>
    </Modal>
  );
};

export default ConfirmRequestJobPostingApprovalModal;
